// Pull URLs from a native drop event (text/uri-list, text/plain)
function isLikelyUrl(s) {
  return /^https?:\/\/\S+/i.test(s);
}

// Pull one or more URLs from a drag/paste event
export async function extractUrlsFromEvent(evt) {
  const urls = new Set();
  const dt = evt?.dataTransfer || evt?.clipboardData;
  if (!dt) return [];

  // 1) Fast path: spec format
  const uriList = dt.getData?.('text/uri-list');
  if (uriList) {
    uriList
      .split(/\r?\n/)
      .map((s) => s.trim())
      .filter((s) => s && !s.startsWith('#') && isLikelyUrl(s))
      .forEach((u) => urls.add(u));
  }

  // 2) Common fallback
  const plain = dt.getData?.('text/plain');
  if (plain) {
    (plain.match(/https?:\/\/\S+/gi) || [])
      .map((u) => u.replace(/[),.;]+$/, '')) // trim trailing punctuation
      .filter(isLikelyUrl)
      .forEach((u) => urls.add(u));
  }

  // 3) HTML (e.g., dragging a link from a page)
  const html = dt.getData?.('text/html');
  if (html) {
    const div = document.createElement('div');
    div.innerHTML = html;
    Array.from(div.querySelectorAll('a[href]'))
      .map((a) => a.getAttribute('href'))
      .filter(isLikelyUrl)
      .forEach((u) => urls.add(u));
  }

  // 4) Items API (Firefox/Safari sometimes only here)
  const items = Array.from(dt.items || []);
  for (const it of items) {
    if (it.kind !== 'string') continue;
    if (
      !['text/uri-list', 'text/plain', 'text/html', 'text/x-moz-url'].includes(
        it.type
      )
    )
      continue;

    const text = await new Promise((res) => it.getAsString(res));

    if (it.type === 'text/uri-list') {
      text
        .split(/\r?\n/)
        .map((s) => s.trim())
        .filter((s) => s && !s.startsWith('#') && isLikelyUrl(s))
        .forEach((u) => urls.add(u));
      continue;
    }

    if (it.type === 'text/html') {
      const div = document.createElement('div');
      div.innerHTML = text;
      Array.from(div.querySelectorAll('a[href]'))
        .map((a) => a.getAttribute('href'))
        .filter(isLikelyUrl)
        .forEach((u) => urls.add(u));
      continue;
    }

    // text/plain or text/x-moz-url (format "<url>\n<title>")
    const firstLine =
      it.type === 'text/x-moz-url' ? text.split(/\r?\n/)[0] : text;
    (firstLine.match(/https?:\/\/\S+/gi) || [])
      .map((u) => u.replace(/[),.;]+$/, ''))
      .filter(isLikelyUrl)
      .forEach((u) => urls.add(u));
  }

  return [...urls];
}
